<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="javascript:;" @click="$router.back()" class="aHref">用户列表</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>详情信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="formUserInfo">

                <el-form ref="authUser" class="info" v-model="authUser" label-width="80px" label-suffix="：">
                    <el-image style="width: 150px; height: 150px" :src="authUser.headImgPath" fit="contain"></el-image>
                    <p class="tit">基本信息</p>
                    <div class="flex">
                        <el-form-item label="真实姓名">
                            <el-input v-model="authUser.fullName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            {{authUser.gender===1?'男': authUser.gender===0? '女':'-'}}
                        </el-form-item>
                    </div>
                    <el-form-item label="年龄">
                        <el-input v-model="authUser.age" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="所在城市">
                        <el-input v-model="authUser.abodeCity" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="职业">
                        <el-input v-model="authUser.workJob" readonly></el-input>
                    </el-form-item>

                </el-form>

                <el-form ref="userSupplement" class="info" v-model="userSupplement" label-width="80px" label-suffix="：">
                    <p class="tit">拓展信息</p>
                    <el-form-item label="身高">
                        <el-input v-model="userSupplement.height" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="体重">
                        <el-input v-model="userSupplement.weight" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="血型">
                        <el-input v-model="userSupplement.bloodType" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="上压">
                        <el-input v-model="userSupplement.bloodUpperPressure" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="下压">
                        <el-input v-model="userSupplement.bloodLowerPressure" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="基础病">
                        <el-input v-model="userSupplement.other" readonly></el-input>
                    </el-form-item>
                </el-form>

            </div>
        </div>
    </div>
</template>

<script>
    import commonjs from "../../api/common";
    export default {
        name: "patientDetail",
        data() {
            return {
                userId: this.$route.params.id,
                authUser: [],
                userSupplement: [],
            }
        },
        mounted() {
            let that = this;
            this.$ajax
                .get(commonjs.api.doctor.patient.detail.replace("{id}", this.userId))
                .then(function (res) {
                    if (res.data.status === 'success') {
                        that.authUser = res.data.data.user;
                        that.userSupplement = res.data.data.supplement || '';
                    }
                })
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.centerPage {
    display: block;

    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
        color: #303139;
    }

    .formUserInfo ::v-deep .el-form-item__content .el-input__inner[readonly="readonly"] {
        border: none;
        color: #303139;
    }

    .formUserInfo ::v-deep .el-form-item__content .el-input__inner {
        color: #666666;
    }

}
label.el-form-item__label:before {
    content: '';
}
</style>
<style lang="css">
.el-form.info .el-form-item{
    margin-bottom: 0;
}
</style>